import { render, staticRenderFns } from "./PayVipModal.vue?vue&type=template&id=ba7da974&scoped=true&"
import script from "./PayVipModal.vue?vue&type=script&lang=js&"
export * from "./PayVipModal.vue?vue&type=script&lang=js&"
import style0 from "./PayVipModal.vue?vue&type=style&index=0&id=ba7da974&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7da974",
  null
  
)

export default component.exports